<div class="card-header">
  <app-breadcrumb currentPage="mijn facturen"></app-breadcrumb>
</div>
<div class="card-body">
  <h2>klik om een factuur te downloaden</h2>
  <div *ngIf="invoices?.length == 0">er zijn geen facturen gevonden</div>
    <div style="width: 700px;">
    <div *ngFor="let invoice of invoices"
         (click)="download(invoice)"
         matRipple
         class="rounded-indent pointer mt28 flex-important">
      <div class="b" style="width:150px">
        {{invoice.payedAt ? invoice.payedAt : translateType(invoice.type)}}
      </div>
      <div style="width:330px">{{invoice.client}}</div>
      <div class="b">
        <app-discount-price
          [amount]="invoice.amount / 100"
          [discount]="invoice.discount">
        </app-discount-price>
      </div>
    </div>
  </div>
</div>

